import { TFunction } from 'i18next';
import compact from 'lodash/compact';
import { StopPlaceSignType } from '../../../../../../types/stop-registry';
import { mapStopPlaceSignTypeToUiName } from '../../../../../../utils/i18n';
import {
  ChangedValue,
  diffKeyedValues,
  mapNullable,
} from '../../../../../common/ChangeHistory';
import { optionalBooleanToUiText } from '../../../Common';
import { HistoricalStopData } from '../../Types';

export function diffSignageDetails(
  t: TFunction,
  previous: HistoricalStopData,
  current: HistoricalStopData,
): Array<ChangedValue> {
  const previousGeneralSign =
    previous.quay?.placeEquipments?.generalSign?.at(0);
  const currentGeneralSign = current.quay?.placeEquipments?.generalSign?.at(0);

  const changes = [
    diffKeyedValues({
      key: 'SignType',
      field: t(($) => $.stopDetails.signs.signType),
      oldValue: previousGeneralSign?.privateCode?.value,
      newValue: currentGeneralSign?.privateCode?.value,
      mapper: mapNullable((v) =>
        mapStopPlaceSignTypeToUiName(t, v as StopPlaceSignType),
      ),
    }),
    diffKeyedValues({
      key: 'NumberOfFrames',
      field: t(($) => $.stopDetails.signs.numberOfFrames),
      oldValue: previousGeneralSign?.numberOfFrames?.toString(10),
      newValue: currentGeneralSign?.numberOfFrames?.toString(10),
    }),
    diffKeyedValues({
      key: 'SignageInstructionExceptions',
      field: t(($) => $.stopDetails.signs.signageInstructionExceptions),
      oldValue: previousGeneralSign?.note?.value,
      newValue: currentGeneralSign?.note?.value,
    }),
    diffKeyedValues({
      key: 'ReplacesRailSign',
      field: t(($) => $.stopDetails.signs.replacesRailSign),
      oldValue: previousGeneralSign?.replacesRailSign,
      newValue: currentGeneralSign?.replacesRailSign,
      mapper: (v) => optionalBooleanToUiText(t, v),
    }),
  ];

  return compact(changes);
}
